<template>
  <div>
    <modal-visualizar-midia
        v-if="modalVisualizarMidia"
        v-model="modalVisualizarMidia"
        :midias="midiasList" :indexInicial="indexMidiaSelecionada"
        @fecharModalVisualizarMidia="fecharModalVisualizarMidia"
        @buscarMidias="buscarMidias"
    />
    <QRCodeModalGaleria
        v-if="modalQRCode"
        v-model="modalQRCode"
        titulo="Enviar foto por QRCode"
        :textoQRCode="textoQRCode"
        :idPaciente="idPaciente"
        gerarToken
        persistencia
        @modalQRCodeFechar="fecharModalQRCode"
    />
    <file-input-modal
        v-if="modalUpload"
        v-model="modalUpload"
        titulo="Envie a foto"
        titulo-btn="Enviar foto"
        content-type="image/png, image/jpeg"
        @selecionarArquivo="realizarUploadFoto"
        @modalInputFechar="fecharModalUpload"
    />
    <div class="mt-5 altura-componente-container">
      <div class="container-controle-midia">
        <v-btn color="primary" class="text-transform-none mr-5" depressed @click="abrirModalUpload">
          <v-icon class="mr-2">photo</v-icon>
          Adicionar foto
        </v-btn>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" @click="abrirModalQRCode" icon class="primary">
              <v-icon color="white">mdi-qrcode</v-icon>
            </v-btn>
          </template>
          Adicionar foto pelo QRCode
        </v-tooltip>
      </div>
      <div v-if="midiasList.length > 0" class="container-galeria">
        <card-midia
            v-for="(midia, index) in midiasList"
            :key="index"
            :midia="midia"
            :index="index"
            @selecionarMidia="abrirModalVisualizarMidia"
        />
      </div>
      <div v-else class="container-galeria-vazio">
        <label>Não há registros de mídias para este paciente.</label>
      </div>
    </div>
  </div>
</template>

<script>
import {actionTypes} from '@/core/constants'
import CardMidia from '@/views/pages/cadastros/paciente/comum/galeria/CardMidia.vue'
import ModalVisualizarMidia from '@/views/pages/cadastros/paciente/comum/galeria/ModalVisualizarMidia.vue'
import FileInputModal from '@/views/components/FileInputModal.vue'
import QRCodeModalGaleria from '@/views/pages/cadastros/paciente/comum/galeria/QRCodeModalGaleria.vue'

export default {
    name: 'PacienteGaleria',
    components: {QRCodeModalGaleria, FileInputModal, ModalVisualizarMidia, CardMidia},
    data() {
        return {
            idPaciente: null,
            midiasList: [],
            paginas: 0,
            totalItens: 0,
            indexMidiaSelecionada: null,
            modalVisualizarMidia: false,
            modalQRCode: false,
            textoQRCode: null,
            modalUpload: false,
        }
    },
    async mounted() {
        this.setarIdPaciente()
        this.montarUrlQRCode()
        await this.buscarMidias()
    },
    methods: {
        setarIdPaciente() {
            if (this.$route.params.id) {
                this.idPaciente = Number(this.$route.params.id)
            }
        },
        montarUrlQRCode() {
            this.textoQRCode = window.origin + '/#/public/paciente/enviar-foto-galeria/'
        },
        async buscarMidias() {
            const resposta = await this.$store.dispatch(actionTypes.GALERIA_PACIENTE.BUSCAR_MIDIAS_PACIENTE, this.idPaciente)
            if (resposta) {
                this.midiasList = resposta.items
                this.paginas = resposta.totalPages
                this.totalItens = resposta.totalElements
            }
        },
        abrirModalUpload() {
            this.modalUpload = true
        },
        fecharModalUpload() {
            this.modalUpload = false
        },
        abrirModalVisualizarMidia(indexMidia) {
            this.indexMidiaSelecionada = indexMidia
            this.modalVisualizarMidia = true
        },
        fecharModalVisualizarMidia() {
            this.modalVisualizarMidia = false
            this.indexMidiaSelecionada = null
        },
        abrirModalQRCode() {
            this.modalQRCode = true
        },
        async fecharModalQRCode() {
            await this.buscarMidias()
            this.modalQRCode = false
        },
        async realizarUploadFoto(arquivo) {
            const input = {
                idPaciente: this.idPaciente,
                arquivo: arquivo
            }
            this.setMensagemLoading('Realizando envio da foto...')
            await this.$store.dispatch(actionTypes.GALERIA_PACIENTE.ENVIAR_MIDIA_PACIENTE, input)
            await this.buscarMidias()
            this.mostrarNotificacaoSucesso('Foto enviada com sucesso!')
            this.fecharModalUpload()
        },
    }
}
</script>

<style scoped lang="stylus">

.container-controle-midia
  display flex
  align-items center
  padding 10px
  border-bottom-width 1px
  border-bottom-style solid
  border-bottom-color #ccc
  box-sizing border-box

.container-galeria
  display grid
  grid-template-columns repeat(auto-fill, minmax(140px, 1fr))
  gap 12px
  padding 12px

.container-galeria-vazio
  display flex
  align-items center
  justify-content center
  height 350px

  label
    color #666

</style>